import { IAppState } from '../../../../../AppModulesWrapper';
import { EServiceId } from '../../../../types/reducers/publishTerms';
import { curry } from 'ramda';
import { IPromotionService } from '../types';
import { selectServices } from './selectServices';

export const selectServiceById = curry((serviceId: EServiceId, state: IAppState): IPromotionService | null => {
  const services = selectServices(state);

  return services.find(service => service.type === serviceId) || null;
});
